
import { useEffect, useState } from "react";
import Header from "@/components/landing/analog-horror/Header";
import HeroSection from "@/components/landing/analog-horror/HeroSection";
import ProblemSolutionSection from "@/components/landing/analog-horror/ProblemSolutionSection";
import FeaturesDemoSection from "@/components/landing/analog-horror/FeaturesDemoSection";
import MonitorVideoSection from "@/components/landing/analog-horror/MonitorVideoSection";
import HorrorNewsSection from "@/components/landing/analog-horror/HorrorNewsSection";
import SocialProofSection from "@/components/landing/analog-horror/SocialProofSection";
import FinalCtaSection from "@/components/landing/analog-horror/FinalCtaSection";
import LandingFooter from "@/components/landing/analog-horror/LandingFooter";
import { ScreenFilterLayer } from "@/components/effects/ScreenFilterLayer";
import "../styles/analog-horror.css";

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [bootComplete, setBootComplete] = useState(false);

  useEffect(() => {
    document.body.classList.add('landing-page');
    
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1500);

    const bootTimer = setTimeout(() => {
      setBootComplete(true);
    }, 4000);

    return () => {
      document.body.classList.remove('landing-page');
      clearTimeout(timer);
      clearTimeout(bootTimer);
    };
  }, []);

  if (!isLoaded) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-black">
        <div className="text-green-500 font-mono text-xl analog-text">
          <p className="mb-2">Initializing Weirdobeach Terminal...</p>
          <div className="w-64 h-4 border border-green-500 relative">
            <div className="absolute top-0 left-0 h-full bg-green-500 analog-scan" style={{ width: "30%" }}></div>
          </div>
        </div>
      </div>
    );
  }

  if (!bootComplete) {
    return (
      <div className="h-screen w-screen flex flex-col items-center justify-center bg-black p-8 font-mono text-green-500 overflow-hidden analog-screen">
        <div className="w-full max-w-4xl analog-text space-y-4">
          <p>{">"} Initializing Limbic Signal Terminal...</p>
          <p>{">"} Synchronizing cosmic protocols... [██░░░░░░] 20%</p>
          <p>{">"} Channeling forgotten signals... [██████░░░] 60%</p>
          <p>{">"} Establishing Neural Interface... [████████░] 90%</p>
          <p className="blink">{">"} System Awakening Complete.</p>
          <p>{">"} Welcome, Initiate.</p>
          <p className="mt-8">{">"} Launching Terminal Interface...</p>
        </div>
        <div className="scanline"></div>
        <div className="noise"></div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen bg-black text-white font-mono overflow-x-hidden analog-screen" style={{ backgroundColor: 'black' }}>
      {/* ScreenFilterLayer is already included globally in Layout - no need for duplicate */}
      <div className="scanline"></div>
      <div className="noise"></div>
      
      <Header />
      <HeroSection />
      <ProblemSolutionSection />
      <FeaturesDemoSection />
      <MonitorVideoSection />
      <HorrorNewsSection />
      <SocialProofSection />
      <FinalCtaSection />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
